module.exports = __webpack_public_path__ + "img/accountEn.062403c2.jpg";